/**
 * L'Invoice project translations - Statuses section
 */

const statuses = {
  // Filter option
  all: "All",
  // Document statuses
  new: "new",
  draft: "draft",
  sent: "sent",
  paid: "paid",
  pending: "pending",
  success: "success",
  received: "received",
  updated: "updated",
  skipped: "skipped",
  declined: "declined",
  error: "error",
  critical: "critical",
  accepted: "accepted",
  submitted: "submitted",
  autoSubmitted: "auto-submitted",
  active: "active",
  warning: "warning",
  attention: "attention",
  suspended: "suspended",
  refund: "refund",
  balanceRefund: "balance refund",
  discontinued: "discontinued",
  alert: "alert",
  voided: "voided",
};

export default statuses;
